import { createDocument, Editor } from '@tiptap/core';
import { closeHistory, redoDepth, undoDepth } from '@tiptap/pm/history';

const RESET_EMPTY_UNDO_BARRIER_STORAGE_KEY = 'crossPlatformHistoryShortcuts';

export const shouldSuppressUndoAtResetBoundary = (editor: Editor): boolean => {
	const resetUndoDepth = editor.storage[RESET_EMPTY_UNDO_BARRIER_STORAGE_KEY]?.resetUndoDepth;
	return typeof resetUndoDepth === 'number' && undoDepth(editor.state) <= resetUndoDepth;
};

export const shouldSuppressRedoAfterReset = (editor: Editor): boolean => {
	const storage = editor.storage[RESET_EMPTY_UNDO_BARRIER_STORAGE_KEY];
	return typeof storage?.resetRedoDepth === 'number' && !storage.hasPostResetEdit && redoDepth(editor.state) > 0;
};

export const recordPostResetEdit = (editor: Editor) => {
	const storage = editor.storage[RESET_EMPTY_UNDO_BARRIER_STORAGE_KEY];
	if (typeof storage?.resetRedoDepth === 'number') {
		storage.hasPostResetEdit = true;
	}
};

export const closeResetHistoryBoundary = (editor: Editor) => {
	const storage = editor.storage[RESET_EMPTY_UNDO_BARRIER_STORAGE_KEY];
	if (storage?.hasClosedPostResetHistoryBoundary) return;
	if (typeof storage?.resetUndoDepth !== 'number') return;

	editor.view.dispatch(closeHistory(editor.state.tr));
	storage.hasClosedPostResetHistoryBoundary = true;
};

export const resetEditorContent = (editor: Editor | null | undefined) => {
	if (!editor) return;

	editor.commands.command(({ tr, dispatch }) => {
		const document = createDocument('', editor.schema, {}, {
			errorOnInvalidContent: editor.options.enableContentCheck,
		});

		if (dispatch) {
			tr.replaceWith(0, tr.doc.content.size, document);
			tr.setMeta('addToHistory', false);
			tr.setMeta('preventUpdate', true);
			dispatch(tr);
		}

		return true;
	});

	const storage = editor.storage[RESET_EMPTY_UNDO_BARRIER_STORAGE_KEY];
	if (storage) {
		storage.resetUndoDepth = undoDepth(editor.state);
		storage.resetRedoDepth = redoDepth(editor.state);
		storage.hasPostResetEdit = false;
		storage.hasClosedPostResetHistoryBoundary = false;
	}
};
